import React from 'react'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { GlobalDiscountRuleState } from './types'
import {
	RuleSummaryArrow,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'

export function GlobalDiscountConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<GlobalDiscountRuleState>) {
	return (
		<RuleSummaryMechanicsRow>
			<RuleSummaryStatBadge
				value={`${rule.threshold} €`}
				caption="panier minimum"
			/>
			<RuleSummaryArrow />
			<RuleSummaryStatBadge
				value={`−${rule.discount}%`}
				caption="sur toute la carte"
				tone="accent"
			/>
		</RuleSummaryMechanicsRow>
	)
}
